import React, { useReducer } from "react";
import axios from "axios";
import CardContext from "./CardContext";
import CardReducer from "./CardReducer";
import {
  USER_CARDS_LOADING,
  USER_CARDS_LOADED,
  USER_CARDS_ERROR,
  SET_CURRENT_CARD,
  CLEAR_CURRENT_CARD,
  CARD_LOADED,
  USER_ORDERS_LOADING,
  USER_ORDERS_LOADED,
  USER_ORDERS_ERROR,
  RECHARGE_CARDS_LOADING,
  RECHARGE_CARDS_LOADED,
  RECHARGE_CARDS_ERROR,
  RESET_CARD,
  SET_CURRENT_ORDER,
  SET_CURRENT_CONTRACT,
  CLEAR_CURRENT_CONTRACT,
  CHECK_SUBSCRIPTION_ALLOWED,
  ORDER_SUBMIT_SUCCESS,
} from "../types";
import { env } from "../../env";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";
const CardState = (props) => {
  const initialState = {
    cards: [],
    error: null,
    isLoading: false,
    loaded: false,
    selectedCard: null,
    orderLoading: false,
    orderLoaded: false,
    orders: [],
    rechargeCards: null,
    changedCards: [],
    completedOrder: "",
    rechargeLoading: false,
    rechargeLoaded: false,
    selectedOrder: localStorage.getItem("selectedOrder")
      ? JSON.parse(localStorage.getItem("selectedOrder"))
      : null,
    subscriptionContract: null,
    rechargeContract: null,
    selectedContract: localStorage.getItem("selectedContract")
      ? JSON.parse(localStorage.getItem("selectedContract"))
      : null,
    isSubscriptionAllowed: null,
  };
  const [state, dispatch] = useReducer(CardReducer, initialState);

  //Reset Context State
  const resetCardState = () => {
    dispatch({
      type: RESET_CARD,
      payload: { ...initialState },
    });
  };

  //Update Card Details
  const updateRechargeCards = (cards) => {
    dispatch({
      type: RESET_CARD,
      payload: { changedCards: cards },
    });
  };

  //Set Data for Subscription selection
  const modifySubscription = (subscriptionContract) => {
    dispatch({
      type: RESET_CARD,
      payload: { subscriptionContract },
    });
  };

  //Set Data for Recharge selection
  const modifyRecharge = (rechargeContract) => {
    dispatch({
      type: RESET_CARD,
      payload: { rechargeContract },
    });
  };

  //Fetch cards for the Loged in User
  const loadUserCards = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "CARD_MANAGEMENT";
      formData.function = "mycards";
      formData.version = "1";
    }
    try {
      console.log("Payload", JSON.stringify(formData));
      dispatch({
        type: USER_CARDS_LOADING,
      });
      const res = await axios.post(`${API_HOST}/card`, formData, config);
      console.log("#########Cards ", res.data);
      // let cards = res.data.cards;
      let cards = await Promise.all(
        res.data.data.map(async (card) => {
          //Fetch card details, update and return updated card
          console.log("Fetching ", card.id);
          card = await loadCardDetails(card, token);
          console.log("#########Card ", card);
          // let cards = res.data.cards;
          return card.data;
        })
      );
      console.log("Done with Iteration");
      dispatch({
        type: USER_CARDS_LOADED,
        payload: cards,
      });
    } catch (err) {
      dispatch({
        type: USER_CARDS_ERROR,
        payload: err,
      });
    }
  };

  //select a card for processing
  const setCurrentCard = (card) => {
    dispatch({
      type: SET_CURRENT_CARD,
      payload: { card },
    });
  };
  //Clear Card Selection
  const clearCurrentCard = () => {
    dispatch({
      type: CLEAR_CURRENT_CARD,
    });
  };
  //Clear contract Selection
  const clearCurrentContract = () => {
    dispatch({
      type: CLEAR_CURRENT_CONTRACT,
    });
  };

  //Fetch card details for all cards for the Loged in User
  const loadCardDetails = async (card, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    let formData = {};
    if (formData) {
      formData.cardId = card.id;
      formData.action = "CARD_MANAGEMENT";
      formData.function = "card_details";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        // dispatch({
        //     type: USER_CARDS_LOADING
        // });
        const res = await axios.post(
          `${API_HOST}/card/details`,
          formData,
          config
        );
        console.log("Card ", res.data);
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Fetch card details for given serial number for anonymous user
  const loadCard = async (card, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    let formData = {};
    if (formData) {
      formData.cardSerialNo = card.cardnumber;
      formData.action = "CARD_MANAGEMENT";
      formData.function = "card_details_serial";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/card/detailsBySerial`,
          formData,
          config
        );
        console.log("Card ", res.data);
        dispatch({
          type: CARD_LOADED,
          payload: res.data.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const loginWithCard = (cardDetails) => {
    dispatch({
      type: CARD_LOADED,
      payload: cardDetails.data,
    });
  };

  //Fetch contract details for given contractId
  const loadContract = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "CONTRACT_MANAGEMENT";
      formData.function = "contract_details";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/contract/details`,
          formData,
          config
        );
        console.log("Contract ", res.data.data);
        dispatch({
          type: SET_CURRENT_CONTRACT,
          payload: res.data.data,
        });
        resolve(res.data.data);
      } catch (err) {
        dispatch({
          type: USER_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Get Orders for the given search criteria given by the User
  const loadOrders = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "ORDER_MANAGEMENT";
      formData.function = "get_orders";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_ORDERS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/order/search`,
          formData,
          config
        );
        console.log("Orders ", res.data);
        dispatch({
          type: USER_ORDERS_LOADED,
          payload: res.data.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_ORDERS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Submit Order without any payment information
  const submitOrder = async (formData, token, user, isSubscription) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    const getFunction = () => {
      if (isSubscription) {
        return "subscription_submit_order";
      } else {
        return user.sponsor ? "rs_submit_order" : "submit_order";
      }
    };
    const formDataFunction = getFunction();
    console.log("FORM DATA", formDataFunction, isSubscription);
    if (formData) {
      formData.action = "ORDER_MANAGEMENT";
      formData.function = formDataFunction;
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_ORDERS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/order/submit`,
          formData,
          config
        );
        if (res && res.data && res.data.data && res.data.data.orderId) {
          console.log("Order ", res.data.data);
          dispatch({
            type: ORDER_SUBMIT_SUCCESS,
            payload: res.data.data.orderId,
          });
        } else {
          dispatch({
            type: USER_ORDERS_ERROR,
            payload: { orderLoading: false },
          });
        }
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_ORDERS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  // //select a card for processing
  // const setCurrentOrder = (orderId) => {
  //   dispatch({
  //     type: SET_CURRENT_CARD,
  //     payload: { card },
  //   });
  // };

  //Fetch order details for given order number
  const getOrderDetails = async (order, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    let formData = {};
    if (formData) {
      formData.orderId = order;
      formData.action = "ORDER_MANAGEMENT";
      formData.function = "get_orders_details";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_ORDERS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/order/getOrdersDetails`,
          formData,
          config
        );
        console.log("Order ", res.data);
        dispatch({
          type: SET_CURRENT_ORDER,
          payload: res.data.data,
        });
        resolve(res.data.data);
      } catch (err) {
        dispatch({
          type: USER_ORDERS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Search cards for recharge
  const getRechargeCards = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "SPONSER_RECHARGE_MANAGEMENT";
      formData.function = "search_recharge_q_cards";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: RECHARGE_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/recharge/rechargeQCards`,
          formData,
          config
        );
        console.log("Cards ", res);
        dispatch({
          type: RECHARGE_CARDS_LOADED,
          payload: res.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: RECHARGE_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Get the individual card contracts for the given card
  const getIndividualContracts = (card) => {
    if (card && card.contracts) {
      if (card.contracts.length > 0) {
        console.log("CARDS-->", card);
        return card.contracts.filter((item) => !item.rideSponsorContract);
      }
    }
  };
  //Get the individual card contracts for the given card
  const getCardsIndividualSubscriptions = (cards) => {
    const updCards = cards.map((card) => {
      let updCard;
      let updContracts = [];

      if (card && card.contracts) {
        if (card.contracts.length > 0) {
          updContracts = card.contracts.filter(
            (item) =>
              item.subscriptionInfo &&
              item.subscriptionInfo.state === "Active" &&
              item.subscriptionInfo.typeOfSubscription === "Individual" &&
              !item.rideSponsorContract
          );
          console.log("SELECT CONTRACT:", card.contracts);
        }
      }
      if (updContracts.length > 0)
        return updContracts.map((item) => {
          updCard = { ...card };
          delete updCard["contracts"];
          const state = item.subscriptionInfo.state;
          const contractId = item.subscriptionInfo.contractId;
          const typeOfSubscription = item.subscriptionInfo.typeOfSubscription;
          const maxNumberOfRecharges =
            item.subscriptionInfo.maxNumberOfRechargesPerPeriod;
          const rechargeValue = (
            item.subscriptionInfo.rechargeValue.rechargeValue / 100
          ).toFixed(2);
          const threshold = (
            item.subscriptionInfo.trigger.threshold / 100
          ).toFixed(2);
          updCard = {
            ...updCard,
            contractId,
            state,
            typeOfSubscription,
            maxNumberOfRecharges,
            threshold,
            rechargeValue,
          };
          return updCard;
        });
      return null;
    });
    return updCards.filter((card) => card !== null).flat(2);
  };

  //Check cards for subscription allowed or not
  const checkSubscriptionAllowed = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "SUBSCRIPTION_MANAGEMENT";
      formData.function = "is_Subscription_Allowed";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/subscription/isSubscriptionAllowed`,
          formData,
          config
        );
        console.log("Cards ", res);
        dispatch({
          type: CHECK_SUBSCRIPTION_ALLOWED,
          payload: res.data.data,
        });
        resolve(res.data.data);
      } catch (err) {
        dispatch({
          type: USER_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Fetch card details for given serial number with ridesponsor contracts
  const loadSponsorContracts = async (card, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    let formData = {};
    if (formData) {
      formData.cardSerialNo = card.cardnumber;
      formData.action = "CARD_MANAGEMENT";
      formData.function = "rs_contracts";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/card/rsContracts`,
          formData,
          config
        );
        console.log("Card ", res.data);
        dispatch({
          type: CARD_LOADED,
          payload: res.data.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: USER_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  return (
    <CardContext.Provider
      value={{
        // cards: state.cards,
        // error: state.error,
        // isLoading: state.isLoading,
        // loaded: state.loaded,
        // selectedCard: state.selectedCard,
        // orderLoading: state.orderLoading,
        // orderLoaded: state.orderLoaded,
        // orders: state.orders,
        // rechargeCards: state.rechargeCards,
        // rechargeLoading: state.rechargeLoading,
        // rechargeLoaded: state.rechargeLoaded,
        // changedCards: state.changedCards
        ...state,
        resetCardState,
        loadUserCards,
        setCurrentCard,
        clearCurrentCard,
        loadCard,
        loadOrders,
        getRechargeCards,
        updateRechargeCards,
        getIndividualContracts,
        getOrderDetails,
        getCardsIndividualSubscriptions,
        modifySubscription,
        modifyRecharge,
        loadContract,
        clearCurrentContract,
        checkSubscriptionAllowed,
        loadSponsorContracts,
        submitOrder,
        loginWithCard,
      }}
    >
      {props.children}
    </CardContext.Provider>
  );
};

export default CardState;
